module.exports = __webpack_public_path__ + "static/media/revengeOfTheSith.785bcec6.jpeg";